import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Small ErrorBoundary — one crashing child panel won't blank out sibling
 * panels in the same tab. Useful when deploying new endpoints that the
 * production backend may not know about yet (graceful degradation).
 */
export default class PanelErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[PanelErrorBoundary]', this.props.label || 'Unknown panel', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="rounded-xl border p-4 flex items-start gap-3" style={{ borderColor: '#FECACA', backgroundColor: '#FEF2F2' }}>
          <AlertTriangle size={18} style={{ color: '#D4726A' }} />
          <div className="flex-1">
            <p className="text-xs font-semibold" style={{ color: '#991B1B' }}>{this.props.label || 'Panel'} could not render</p>
            <p className="text-[11px] mt-1" style={{ color: '#991B1B' }}>
              {String(this.state.error?.message || this.state.error).slice(0, 180)}
            </p>
            <p className="text-[11px] mt-2" style={{ color: '#6B7280' }}>
              Other panels on this page are not affected. Try a hard-refresh (Ctrl+Shift+R) or contact support.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
